var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}


Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);
var TAG_NAME = 'upd-focus-out';

var template = document.createElement('template');
template.innerHTML = '\n  <style>\n    :host {\n      display: block;\n    }\n  </style>\n\n  <slot></slot>\n';

var HAS_SHADY_CSS = window.hasOwnProperty('ShadyCSS');
if (HAS_SHADY_CSS) {
  window.ShadyCSS.prepareTemplate(template, TAG_NAME);
}

var FocusOut = function (_CustomElement2) {
  _inherits(FocusOut, _CustomElement2);

  _createClass(FocusOut, null, [{
    key: 'observedAttributes',
    get: function get() {
      // Using `is-disabled` since IE11 will restyle inputs/buttons
      // when an ancestor is `disabled`. If we ever drop IE11 support,
      // we might want to revisit the naming here to align with native
      // `disabled` attribute/properties
      return ['is-disabled'];
    }
  }]);

  function FocusOut() {
    _classCallCheck(this, FocusOut);

    var _this = _possibleConstructorReturn(this, (FocusOut.__proto__ || Object.getPrototypeOf(FocusOut)).call(this));

    _this._handleFocusOut = function (event) {
      // Need setTimeout or else the document.activeElement will be incorrect.
      setTimeout(function () {
        if (!isActiveElementInside(_this, deepActiveElement())) {
          _this.dispatchEvent(new CustomEvent('updfocusout', {
            bubbles: true,
            composed: true
          }));
        }
      }, 0);
    };

    _this.attachShadow({ mode: 'open' });
    _this.shadowRoot.appendChild(template.content.cloneNode(true));
    return _this;
  }

  _createClass(FocusOut, [{
    key: 'connectedCallback',
    value: function connectedCallback() {
      // Shim Shadow DOM styles. Needs to be run in connectedCallback.
      // Needed for IE 11.
      if (HAS_SHADY_CSS) {
        window.ShadyCSS.styleElement(this);
      }

      this._addListener();
    }
  }, {
    key: 'attributeChangedCallback',
    value: function attributeChangedCallback(name) {
      if (name === 'is-disabled') {
        this.isDisabled ? this._removeListener() : this._addListener();
      }
    }
  }, {
    key: '_addListener',
    value: function _addListener() {
      this.addEventListener('focusout', this._handleFocusOut);
    }
  }, {
    key: '_removeListener',
    value: function _removeListener() {
      this.removeEventListener('focusout', this._handleFocusOut);
    }
  }, {
    key: 'isDisabled',
    set: function set(value) {
      Boolean(value) ? this.setAttribute('is-disabled', '') : this.removeAttribute('is-disabled');
    },
    get: function get() {
      return this.hasAttribute('is-disabled');
    }
  }]);

  return FocusOut;
}(_CustomElement);

window.customElements.define(TAG_NAME, FocusOut);

// Walk backwards up the DOM from the activeElement to
// either the focus-out component or the root to determine
// if the activeElement is inside focus-out still.
function isActiveElementInside(element, activeElement) {
  var a = activeElement;
  while (element !== a && (a.assignedSlot || a.parentNode || a.host)) {
    a = a.assignedSlot || a.parentNode || a.host;
  }
  return element === a;
}

// Due to how Shadow DOM currently works, we have to walk
// down all shadowRoots to get the actual activeElement
function deepActiveElement() {
  var a = document.activeElement;
  while (a && a.shadowRoot && a.shadowRoot.activeElement) {
    a = a.shadowRoot.activeElement;
  }
  return a;
}
